import React from 'react'
import translator from 'i18next'
import { map, omit } from 'lodash'
import { Form, DatePicker, Skeleton } from 'antd'
import { YEAR_DATETIME_FORMAT } from 'constants/formats'

const { RangePicker } = DatePicker 

export default props => {
    const {
        onChange,
        name,
        schema = {},
        format,
        formItemProps = {},
        loading = false,
    } = props

    const handleChange = (value, e) => {
        if (onChange) {
            onChange(name, value, e)
        }
    }

    let Component = (
        <>
            {props.text ? <strong>{translator.t(props.text)}</strong> : ''}
            <RangePicker
                format={format || YEAR_DATETIME_FORMAT}
                rows={4}
                {...omit(props, ['loading'])}
                onChange={handleChange}
                style={{ width: '100%' }}
                showTime
            />
        </>
    )
    let formProps = {}

    if (name && schema[name]) {
        const fieldSchema = schema[name]
        const label = props.text || fieldSchema.label

        Component = (
            <RangePicker
                format={format || YEAR_DATETIME_FORMAT}
                rows={4}
                {...omit(props, ['loading'])}
                placeholder={map(props.placeholder, holder =>
                    translator.t(holder)
                )}
                onChange={handleChange}
                showTime
            />
        )
        formProps = {
            name,
            label: translator.t(label),
            rules: map(fieldSchema.rules, rule => ({
                ...rule,
                message: translator.t(rule.message),
            })),
        }
    }

    if (loading) Component = <Skeleton.Input active />

    return (
        <Form.Item className='form-item' {...formProps} {...formItemProps}>
            {Component}
        </Form.Item>
    )
}
